import { Typography } from "@mui/material"
import IconBox from "../../IconBox"
import { OperationDetailsProps } from "../props"
import {
  AccordionBody,
  AccordionHeader,
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailsContainerTextOverflow,
  DetailValue,
  IconContainer,
  ScrollContainer,
  SourceDescription,
  StatusChecked,
  StyledAccordion,
  StyledDivider,
  Subtext,
  TopContainer,
} from "../styled"
import UIIcon from "../../UIIcon"
import SBPIconNoExt from "../../SBPIconNoExt"
import { formatAmount, formatPhoneNumber } from "../../../utils/formatters"
import { RUBLE } from "../../../utils/constants"
import { getOperationStatusDetails } from "../../../utils/operation"
import { getTimezone } from "../../../utils/datetime"

const SbpIncomeTransferHistoryDetails = ({
  operation,
  isRefund,
}: OperationDetailsProps) => {
  const operationNumber = operation.fields.find(
    (f) => f.name === "OperationNumber",
  )
  const payerPhoneNumber = operation.fields.find(
    (f) => f.name === "PayerPhoneNumber",
  )
  const payerPAM = operation.fields.find((f) => f.name === "PayerPAM")
  const payerBankName = operation.fields.find((f) => f.name === "PayerBankName")
  const description = operation.fields.find((f) => f.name === "Description")

  const statusDetails = getOperationStatusDetails(operation)

  const iconName = isRefund ? "incomeGrey" : "incomeGrey"

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg" color="yellow">
            <UIIcon
              iconName={
                statusDetails.isSuccesseful ? iconName : statusDetails.icon
              }
              size={80}
            />
          </IconBox>
          <SourceDescription>
            {payerPAM?.value || payerPhoneNumber?.value}
          </SourceDescription>
          <Amount>
            {formatAmount(operation.amount)} {RUBLE}
          </Amount>
          <Subtext>
            {isRefund ? "Возврат входящего перевода" : "Зачисление по СБП"}
          </Subtext>
        </TopContainer>
        <StyledDivider />
        <StyledAccordion>
          <AccordionHeader
            expandIcon={<UIIcon iconName="arrowDown" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h4">Подробнее об операции</Typography>
          </AccordionHeader>
          <AccordionBody>
            <DetailsContainer sx={DetailsContainerTextOverflow}>
              <DetailContainer>
                <DetailLabel>Статус операции</DetailLabel>
                <DetailValue>
                  <StatusChecked statusColor={statusDetails.color}>
                    {statusDetails.message}
                  </StatusChecked>
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер операции в РНКО «Единая Касса»</DetailLabel>
                <DetailValue>{operation.contextOperationId}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер телефона отправителя</DetailLabel>
                <DetailValue>
                  {payerPhoneNumber
                    ? formatPhoneNumber(payerPhoneNumber?.value)
                    : ""}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>ФИО отправителя</DetailLabel>
                <DetailValue>{payerPAM?.value}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Банк отправителя</DetailLabel>
                <DetailValue>{payerBankName?.value}</DetailValue>
              </DetailContainer>
              {description?.value && (
                <DetailContainer>
                  <DetailLabel>Сообщение</DetailLabel>
                  <DetailValue>{description?.value}</DetailValue>
                </DetailContainer>
              )}
              <DetailContainer>
                <DetailLabel>Сумма перевода</DetailLabel>
                <DetailValue>
                  {formatAmount(operation.amount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер операции в СБП</DetailLabel>
                <DetailValue>{operationNumber?.value}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Дата и время операции</DetailLabel>
                <DetailValue>{getTimezone(operation.updatedOn)}</DetailValue>
              </DetailContainer>
            </DetailsContainer>
          </AccordionBody>
        </StyledAccordion>
        <IconContainer>
          <SBPIconNoExt size={60} />
        </IconContainer>
      </ScrollContainer>
    </ContentContainer>
  )
}

export default SbpIncomeTransferHistoryDetails
